import {
  SET_USER_ROLES,
  FETCH_USER_POSITIONS,
  FETCH_USER_POSITIONS_FAILED,
  FETCH_USER_POSITIONS_SUCCESS,
} from './user-actions';

export const USER_STATE_KEY = 'USER_REDUCER';

export interface IUserState {
  roles: string[];
  isEditAllowed: boolean;
  isAccessDenied: boolean;
  userPositions: string[];
}

const defaultState: IUserState = {
  roles: [],
  isEditAllowed: false,
  isAccessDenied: true,
  userPositions: [],
};

export const userReducer = (state = defaultState, { type, payload }: any) => {
  switch (type) {
    case SET_USER_ROLES:
      return {
        ...state,
        roles: payload,
        isEditAllowed: payload.includes('write'),
        isAccessDenied: !payload.length,
      };
    case FETCH_USER_POSITIONS:
    case FETCH_USER_POSITIONS_FAILED:
      return {
        ...state,
        userPositions: [],
      };
    case FETCH_USER_POSITIONS_SUCCESS:
      return {
        ...state,
        userPositions: payload,
      };
    default:
      return state;
  }
};

export const getIsAccessDenied = (state: any) => state[USER_STATE_KEY].isAccessDenied;
export const getIsEditAllowed = (state: any) => state[USER_STATE_KEY].isEditAllowed;
export const getUserRoles = (state: any) => state[USER_STATE_KEY].roles;
export const getWriteTabsPermissions = (state: any) => state[USER_STATE_KEY].writeTabsPermissions;
export const getUserPositions = (state: any) => state[USER_STATE_KEY].userPositions.Positions;
